export default "__VITE_ASSET__NF2f8Utu__"